import { useMediaQuery, useTheme } from '@mui/material';
import { MOBILE_BREAKPOINT_PX } from 'utils/constants';

const useIsMobile = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(MOBILE_BREAKPOINT_PX));
};

export default useIsMobile;
